export default "__VITE_ASSET__hrPwZjI1__"